import React, { useEffect, useState, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";

import HeaderUser from "../components/homePage/HeaderUser";
import FooterPage from "../components/homePage/FooterPage";
import ChatWindow from "../components/ChatWindow";
import ChatMemberList from "../components/ChatMemberList";
import ChatOnlineMatches from "../components/ChatOnlineMatches";

import { createUser, createChatUser } from "../services/chatService";

export default function ChatPage() {
  const { profileId: partnerId } = useParams();
  const { userDetailLogin } = useSelector((state) => state.auth);

  const [selfUser, setSelfUser] = useState(null);
  const [partnerUser, setPartnerUser] = useState(null);
  const [isChatReady, setIsChatReady] = useState(false);

  const rawToken = Cookies.get("authTokenUserLogin") || Cookies.get("authTokenUser");
  
  const token = useMemo(() => {
    try {
      return rawToken ? JSON.parse(decodeURIComponent(rawToken)) : null;
    } catch (e) {
      return null;
    }
  }, [rawToken]);

  const fetchUser = async (id, setter) => {
    if (!id || !token) return;
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL_API}/api/user/user-detail/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await res.json();
      setter(data?.data || null);
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  useEffect(() => {
    if (userDetailLogin?._id) fetchUser(userDetailLogin._id, setSelfUser);
    if (partnerId) fetchUser(partnerId, setPartnerUser);
  }, [userDetailLogin?._id, partnerId, token]);
  
  const me = useMemo(() => {
  if (!Array.isArray(selfUser) || !selfUser[0]?.profile_id) return null;

  return {
    id: selfUser[0].profile_id,
    primary_id: selfUser[0]._id,
    name: selfUser[0].name,
    image: "https://vivashri.com/vivashribackend/"+selfUser[0].photo,
    is_online: true,
    about: "Hey, I'm using chat",
    created_at: String(Date.now()),
    email: "",
    last_active: "",
    last_active_status: 0,
    online_status: 0,
    push_token: "",
  };
}, [selfUser]);

const getPartnerImage = () => {
  if (partnerUser?.[0]?.photo) {
    return `https://vivashri.com/vivashribackend/${partnerUser[0].photo}`;
  }
  if (partnerUser?.[0]?.gender === "Female") {
    return "https://vivashri.com/vivashribackend/images/default-female.png";
  }
  return "https://vivashri.com/vivashribackend/images/default-male.png";
};


const partner = useMemo(() => {
  if (!Array.isArray(partnerUser) || !partnerUser[0]?.profile_id) return null;

  return {
    id: partnerUser[0].profile_id,
    primary_id: partnerUser[0]._id,
    name: partnerUser[0].name || "",
    image: getPartnerImage(),
    is_online: true,
    about: "Hey, I'm using chat",
    created_at: String(Date.now()),
    email: "",
    last_active: "",
    last_active_status: 0,
    online_status: 0,
    push_token: "",
  };
}, [partnerUser]);


  useEffect(() => {
    console.log("before", me)
     if (!me || !partner) return;
     

    const initChat = async () => {
      try {
        await createUser(me.id, me);
        await createUser(partner.id, partner);
        await createChatUser(me.id, partner);
        await createChatUser(partner.id, me);
        setIsChatReady(true);
      } catch (error) {
        console.error("Chat init error:", error);
        setIsChatReady(false);
      }
    };

    initChat();
  }, [ me, partner]);
 
  console.log('check data', partner);
  return (
    <>
      <HeaderUser />
      <section>
        <div className="register-sec chat-top-bar">
          <div className="container-fluid">
            <div className="mx-2">
              <div className="row">
                <div className="col-md-8">
                  <ChatOnlineMatches />
                  <div className="chat-now">
                    <h5>Online Chat</h5>
                  </div>
                  {isChatReady ? (

                  <ChatMemberList partnerUser={partnerUser} selfUser={selfUser} />

                  ) : (
                      <div className="text-center p-5">
                        <p>Loading Chat...</p>
                      </div>
                    )}
                </div>
                <div className="col-md-4">
                  <div style={{ maxWidth: "600px" }}>
                    {isChatReady ? (
                      <ChatWindow me={me} partner={partner} />
                    ) : (
                      <div className="text-center p-5">
                        <p>Loading Chat...</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <FooterPage />
    </>
  );
}